import GoogleAnalytics from '../adapter/GoogleAnalytics';

type TimestampFn = () => number;

class PerformanceMeasure {
  private googleAnalytics: GoogleAnalytics;
  private timestampFn: TimestampFn;

  constructor({ googleAnalytics, timestampFn }: { googleAnalytics: GoogleAnalytics; timestampFn?: TimestampFn }) {
    this.googleAnalytics = googleAnalytics;

    if (timestampFn) {
      this.timestampFn = timestampFn;
    } else if (typeof performance.now !== 'function') {
      this.timestampFn = () => Date.now();
    } else {
      this.timestampFn = () => performance.now();
    }
  }

  start(name: string): { startTime: number; stop: () => void } {
    const startTime = this.timestampFn();

    return {
      startTime,
      stop: () => {
        const durationMs = this.timestampFn() - startTime;
        this.googleAnalytics.sendUserTiming(name, durationMs);
      },
    };
  }
}

export default PerformanceMeasure;
